import React from 'react';
import { Link } from 'react-router-dom';
import type { BuiltInGuideTopic } from '../../content/gameGuideBuiltIn';

type Props = {
    topics: BuiltInGuideTopic[];
    readLabel: string;
};

const GameGuideTopicGrid: React.FC<Props> = ({ topics, readLabel }) => (
    <ul className="game-topic-grid">
        {topics.map((topic) => {
            const to = topic.href ?? `/game/${topic.slug}`;
            const isExternal = Boolean(topic.href);

            return (
                <li key={topic.slug}>
                    <Link to={to} className="game-topic-card">
                        <span className="game-topic-card-icon" aria-hidden>
                            <i className={topic.icon} />
                        </span>
                        <div className="game-topic-card-body">
                            <h3>{topic.title}</h3>
                            <p>{topic.summary}</p>
                            <span className="game-topic-card-action">
                                {readLabel}
                                <i className={isExternal ? 'ri-external-link-line' : 'ri-arrow-right-line'} />
                            </span>
                        </div>
                    </Link>
                </li>
            );
        })}
    </ul>
);

export default GameGuideTopicGrid;
